module.exports = __webpack_public_path__ + "static/img/7.386f56c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/7.png
// module id = 8W/K
// module chunks = 0